import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["productInput"]

  displayRelevantProducts(e) {
    const selectedYear = e.target.value

    this.productInputTarget.value = ""

    Array.from(this.productInputTarget.options).forEach((option) => {
      if (option.value === "") return

      option.toggleAttribute("hidden", option.dataset.year !== selectedYear)
    })
  }

  refreshHknItems(event) {
    const productId = event.target.value
    const yearlyMixElement = document.getElementById("yearly_mix")

    if (productId) {
      yearlyMixElement.src = `/client/products/${productId}/yearly_mix`
    }
  }
}
